import http from "../../http";
import ApiConstants from "../../constants/ApiConstants";

class ModuleAccessControlService {
	static get() {
		return http.get(ApiConstants.URL.MODULE_ACCESS_CONTROL.GET);
	}

	static save(payload) {
		return http.post(ApiConstants.URL.MODULE_ACCESS_CONTROL.SAVE, payload);
	}
}

export default ModuleAccessControlService;
